import React, { useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import ToggleButton from '@material-ui/lab/ToggleButton';
import { makeStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import AddIcon from '@material-ui/icons/Add';
import NavBar from './NavBar';
import DemoVideo from './videos/eccv_teaser_final_corrected.mp4';
import FullVideo from './videos/eccv_long_corrected_v3.mp4';
import examples from './examples.json';
import PaperThumbnail from './images/paper_thumbnail.png';
import Psvg from './images/paper.svg';
import Teaser from './images/abstraction_teaser_fig.png';
import github from './images/github.svg';
import './App.css';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textHeader: {
    padding: 32,
    width: '75%',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  abstractionExample: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  abstractionExamples: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  videoButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  examples: {
    background: '#A1908D',
    width: '100vw',
    marginTop: 64,
  },
  setCompletion: {
    display: 'flex',
    flexDirection: 'row',
    padding: 32,
    justifyContent: 'space-evenly',
    [theme.breakpoints.down("sm")]: {
      flexDirection: 'column',
    },
  },
  paperSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down("sm")]: {
      flexDirection: 'column',
    },
  },
  paperText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 16,
  },
  avatarContainer: {
    width: 128,
    height: 128,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: "20% 80% 20% 80% / 56% 23% 77% 44%  ",
    marginBottom: 16,
  },
  imgSizing: {
    width: 128,
  },
  personContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 32,
  },
  roleText: {
    fontWeight: 100,
    color: "black",
    fontSize: "0.5rem",
    textAlign: "center",
  },
  nameText: {
    fontWeight: 200,
    fontSize: "1rem",
    textAlign: "center",
  },
  peopleContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  oddOutExamples: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
    [theme.breakpoints.down("sm")]: {
      flexDirection: 'column',
    },
  },
  divider: {
    backgroundColor: "#a31f34",
    width: '100vw',
    height: '1vh',
  },
  copyright: {
    display: 'flex',
    backgroundColor: '#8a8b8c',
    color: 'white',
    width: '100vw',
    justifyContent: 'center',
    padding: 4,
    fontSize: 8,
  },
  exsButton: {
    margin: 8,
  },
  centerCrop: {
   overflow: 'hidden',
   display: 'flex',
   justifyContent: 'center',
   alignItems: 'center',
   width: 180,
   height: 180,
   margin: 16,
   [theme.breakpoints.down('sm')]: {
      marginRight: 4,
    }
  },
  sideBySide: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down("sm")]: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
}));

const people = {
  "Alex Andonian": {
    "src": './images/alex.png',
    "email": 'andonian-AT-mit.edu',
  },
  "Camilo Fosco": {
    "src": "./images/Camilo.png",
    "email": "camilolu-AT-mit.edu",
  },
  "Mathew Monfort": {
    "src": "./images/Mathew.png",
    "email": 'mmonfort-AT-mit.edu',
  },
  "Allen Lee": {
    "src": "./images/Allen.jpg",
    "email": "allenlee-AT-mit.edu",
  },
  "Rogerio Feris": {
    "src": "./images/rogerio.jpg",
    "email": "rsferis-AT-us.ibm.com",
  },
  "Carl Vondrick": {
    "src": "./images/carl.jpg",
    "email": "vondrick-AT-cs.columbia.edu",
  },
  "Aude Oliva": {
    "src": "./images/Aude.jpg",
    "email": "oliva-AT-mit.edu",
  },
}

function App(props) {
  const classes = useStyles();
  const [abstractionVideos, setAbstractionVideos] = useState(examples[1]["abstraction"]["videos"]);
  const [abstractions, setAbstractions] = useState(examples[1]["abstraction"]["abstractions"]);
  const [completionAnswer, setCompletionAnswer] = useState(examples[1]["setcompletion"]["answer"]);
  const [completionVideos, setCompletionVideos] = useState(examples[1]["setcompletion"]["videos"]);
  const [oddAnswer, setOddAnswer] = useState(examples[1]["oddoneout"]["answer"]);
  const [oddVideos, setOddVideos] = useState(examples[1]["oddoneout"]["videos"]);
  const [button1, setButton1] = useState(false);
  const [button2, setButton2] = useState(false);
  const [button3, setButton3] = useState(false);
  const [completion, setCompletion] = useState("");
  const [odd, setOdd] = useState("");

  function getExamples(val) {
    setAbstractionVideos(examples[val]["abstraction"]["videos"]);
    setAbstractions(examples[val]["abstraction"]["abstractions"]);
    setCompletionVideos(examples[val]["setcompletion"]["videos"]);
    setCompletionAnswer(examples[val]["setcompletion"]["answer"]);
    setOddVideos(examples[val]["oddoneout"]["videos"]);
    setOddAnswer(examples[val]["oddoneout"]["answer"]);
    setButton1(false);
    setButton2(false);
    setButton3(false);
    setCompletion("");
    setOdd("");
  }

  function getAbstraction() {
    if (button1 && button2 && button3) {
      return abstractions["012"];
    } else if (button1 && button2) {
      return abstractions["01"];
    } else if (button1 && button3) {
      return abstractions["02"];
    } else if (button2 && button3) {
      return abstractions["12"];
    } else if (button1) {
      return abstractions["0"];
    } else if (button2) {
      return abstractions["1"];
    } else if (button3) {
      return abstractions["2"];
    } else {
      return "Select Video(s)";
    }
  }

  return (
    <div className={classes.root}>
      <NavBar {...props} />
      <div id="#"></div>
      <div className={classes.textHeader}>
        <Typography variant="h3" gutterBottom style={{marginTop: 32, fontWeight: 200}}>
          We Have So Much In Common: Modeling Semantic Relational Set Abstractions in Videos
        </Typography>
        <Typography variant="caption" gutterBottom>
          Alex Andonian<sup>*1</sup>, Camilo Fosco<sup>*1</sup>, Mathew Monfort<sup>1</sup>,
          Allen Lee<sup>1</sup>, Rogerio Feris<sup>2</sup>, Carl Vondrick<sup>3</sup>, and Aude Oliva<sup>1</sup>.
          <br />
          <sup>1</sup>Massachusetts Institute of Technology, <sup>2</sup>MIT-IBM Watson AI Lab, <sup>3</sup>Columbia University
          <br />
          <sup>*</sup>Equal contribution.
        </Typography>
        <Typography variant="subtitle1" align="left" style={{width: "80%", marginTop: 16, fontWeight: 100}}>
          Identifying common patterns among events is a key ability in human and machine perception,
          as it underlies intelligent decision making. We propose an approach for learning semantic
          relational set abstractions on videos, inspired by human learning. We combine visual features
          with natural language supervision to generate high-level representations of similarities across
          a set of videos. This allows our model to perform cognitive tasks such as set abstraction
          (which general concept is in common among a set of videos?), set completion (which new video
          goes well with the set?), and odd one out detection (which video does not belong to the set?).
          Experiments on two video benchmarks, Kinetics and Multi-Moments in Time, show that robust and
          versatile representations emerge when learning to recognize commonalities among sets. We compare
          our model to several baseline algorithms and show that significant improvements result from
          explicitly learning relational abstractions with semantic supervision.
        </Typography>
        <Typography variant="h6" style={{marginTop:16, fontWeight: 100}}>Short Presentation (1 minute)</Typography>
        <video src={DemoVideo} style={{marginTop: 16, border: "20px groove #ddd"}} controls width="70%" />
        <Typography variant="h6" style={{marginTop:16, fontWeight: 100}}>Full Presentation (10 minutes)</Typography>
        <video src={FullVideo} style={{marginTop: 16, border: "20px groove #ddd"}} controls width="70%" />
        <div id="Examples"></div>
        <div className={classes.examples}>
          <Typography variant="h4" style={{marginTop: 32,fontWeight: 200}} >
            Examples of Abstraction, Set Completion, and Odd One Out
          </Typography>
          <div className={classes.exampleSelector}>
            {
              Object.keys(examples).map((val) => {
                return(
                  <Button variant="contained" className={classes.exsButton} onClick={() => getExamples(val)}>
                    {val}
                  </Button>
                );
              })
            }
          </div>
          <Typography style={{fontWeight: 100}}>
            Explore Different Sets of Examples
          </Typography>
          <Typography variant="h5" style={{marginTop: 16, fontWeight: 100}}>
            Abstraction: {getAbstraction()}
          </Typography>
          <Typography variant="h6" style={{marginBottom: 16, fontWeight: 100}} >
            Select Videos to Examine Model Abstractions
          </Typography>
          <div className={classes.abstractionExamples}>
            <div className={classes.videoButtonContainer} style={{maxWidth: "30%"}}>
              <div className={classes.centerCrop}>
                <video src={require(""+abstractionVideos[0])} width="320" autoPlay muted loop />
              </div>
              <ToggleButton style={{color: "black", marginBottom: 16}} value="check" selected={button1} onChange={() => {setButton1(!button1)}}>
                <AddIcon />
              </ToggleButton>
            </div>
            <div className={classes.videoButtonContainer} style={{maxWidth: "30%"}}>
              <div className={classes.centerCrop}>
                <video src={require(""+abstractionVideos[1])} autoPlay muted loop width="320" />
              </div>
              <ToggleButton style={{color: "black", marginBottom: 16}} value="check" selected={button2} onChange={() => {setButton2(!button2)}}>
                <AddIcon />
              </ToggleButton>
            </div>
            <div className={classes.videoButtonContainer} style={{maxWidth: "30%"}}>
              <div className={classes.centerCrop}>
                <video src={require(""+abstractionVideos[2])} autoPlay muted loop width="320" />
              </div>
              <ToggleButton style={{color: "black", marginBottom: 16}} value="check" selected={button3} onChange={() => {setButton3(!button3)}}>
                <AddIcon />
              </ToggleButton>
            </div>
          </div>
          <hr style={{marginTop: 16, background: "#A1908D", opacity: 0.7}} />
          <Typography variant="h5" style={{marginTop: 32, fontWeight: 100}}>
            Set Completion
          </Typography>
          <Typography variant="h6" style={{marginBottom: 16, fontWeight: 100}}>
            Select the Video Most Similar to the Reference
          </Typography>
          {
            completion ?
              (
                completion == completionAnswer ?
                  <Typography>
                    You and the model chose the same!
                  </Typography>
                :
                  <Typography>
                    You and the model chose differently.
                  </Typography>
              )
              :
              <React.Fragment />
          }
          <div className={classes.setCompletion}>
            <div className={classes.reference}>
              <Typography variant="h6" style={{fontWeight: 100}}>
                Reference Videos
              </Typography>
              <div className={classes.sideBySide}>
                <div className={classes.centerCrop}>
                  <video src={require(""+completionVideos[0])} width={320} autoPlay loop muted />
                </div>
                <div className={classes.centerCrop}>
                  <video src={require(""+completionVideos[1])} width={320} autoPlay loop muted />
                </div>
              </div>
            </div>
            <div className={classes.choices}>
              <Typography variant="h6" style={{fontWeight: 100}}>
                Set Completion Choices
              </Typography>
              <div className={classes.abstractionExample}>
                <div className={classes.videoButtonContainer}>
                  <div className={classes.centerCrop} style={{border: completionAnswer == "2" && completion == completionAnswer ?"6px solid #519872":(completion == "2" ? "6px solid #c26565" : "none"), marginBottom: 8}}>
                    <video src={require(""+completionVideos[2])} width={320} autoPlay loop muted />
                  </div>
                  <Button style={{marginBottom: 16}} variant="contained" onClick={() => setCompletion("2")} ><CheckIcon /></Button>
                </div>
                <div className={classes.videoButtonContainer}>
                  <div className={classes.centerCrop} style={{border: completionAnswer == "3" && completion == completionAnswer ? "6px solid #519872": (completion == "3" ? "6px solid #c26565" : "none"), marginBottom: 8}}>
                    <video src={require(""+completionVideos[3])} width={320} autoPlay loop muted />
                  </div>
                  <Button style={{marginBottom: 16}} variant="contained" onClick={() => setCompletion("3")}><CheckIcon /></Button>
                </div>
              </div>
            </div>
          </div>
          <hr style={{marginTop: 16, background: "#A1908D", opacity: 0.7}} />
          <div className={classes.oddOut}>
            <Typography variant="h5" style={{marginTop: 32, fontWeight: 100}}>
              Odd One Out
            </Typography>
            <Typography variant="h6" style={{marginBottom: 16, fontWeight: 100}}>
              Select the Odd One Out Video
            </Typography>
            {
              odd ?
                (
                  odd == oddAnswer ?
                    <Typography>
                      You and the model chose the same!
                    </Typography>
                  :
                    <Typography>
                      You and the model chose differently.
                    </Typography>
                )
                :
                <React.Fragment />
            }
            <div className={classes.oddOutExamples}>
              <div className={classes.videoButtonContainer}>
                <div className={classes.centerCrop} style={{border: oddAnswer == "0" && odd == oddAnswer ?"6px solid #519872":(odd == "0" ? "6px solid #c26565" : "none"),marginBottom: 8}}>
                  <video src={require(""+oddVideos[0])} width={320} autoPlay loop muted />
                </div>
                <Button style={{marginBottom: 16}} variant="contained" onClick={() => setOdd("0")} ><CheckIcon /></Button>
              </div>
              <div className={classes.videoButtonContainer}>
                <div className={classes.centerCrop} style={{border: oddAnswer == "1" && odd == oddAnswer ?"6px solid #519872":(odd == "1" ? "6px solid #c26565" : "none"), marginBottom: 8}}>
                  <video src={require(""+oddVideos[1])} width={320} autoPlay loop muted />
                </div>
                <Button style={{marginBottom: 16}} variant="contained" onClick={() => setOdd("1")} ><CheckIcon /></Button>
              </div>
              <div className={classes.videoButtonContainer}>
                <div className={classes.centerCrop} style={{border: oddAnswer == "2" && odd == oddAnswer ?"6px solid #519872":(odd == "2" ? "6px solid #c26565" : "none"),marginBottom: 8}}>
                  <video src={require(""+oddVideos[2])} width={320} autoPlay loop muted />
                </div>
                <Button style={{marginBottom: 16}} variant="contained" onClick={() => setOdd("2")} ><CheckIcon /></Button>
              </div>
        <div id="Paper"></div>
            </div>
          </div>
        </div>
        <Typography variant="h4" style={{marginTop: 16,fontWeight: 200}}>
          Paper
        </Typography>
        <div className={classes.paperSection}>
          <img src={PaperThumbnail} style={{marginLeft: 16, marginRight: 16, height: 324, marginTop: 16}} />
          <div className={classes.paperText}>
            <Typography variant="subtitle1" style={{fontWeight: 100}} gutterBottom align="left">
              Alex Andonian<sup>*1</sup>, Camilo Fosco<sup>*1</sup>, Mathew Monfort<sup>1</sup>,
              Allen Lee<sup>1</sup>, Rogerio Feris<sup>2</sup>, Carl Vondrick<sup>3</sup>, and Aude Oliva<sup>1</sup>.
              <br />
              European Conference on Computer Vision (ECCV), 2020.
              <br />
              <Typography variant="caption">
              <sup>1</sup>Massachusetts Institute of Technology, <sup>2</sup>MIT-IBM Watson AI Lab, <sup>3</sup>Columbia University
              <br/>
              <sup>*</sup>Equal contribution.
              </Typography>
            </Typography>
            <img src={Psvg} width={64} />
            <div className={classes.sideBySide}>
              <a href="https://arxiv.org/abs/2008.05596" style={{marginTop: 8, textDecoration: "none"}} >
                <Typography>
                  [ arXiv ]
                </Typography>
              </a>
              <a href="https://news.mit.edu/2020/toward-machine-learning-that-can-reason-about-everyday-actions-0831" style={{marginTop: 8, textDecoration: "none"}}>
                <Typography>
                  [ MIT News ]
                </Typography>
              </a>
            </div>
          </div>
        </div>
        <div id="Code"></div>
        <div className={classes.examples} style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',}}>
          <Typography variant="h4" style={{marginTop: 32,fontWeight: 200}}>
            Code
          </Typography>
          <img src={Teaser} style={{marginTop: 16, marginBottom: 16,}} width="70%" />
          < a href="https://github.com/alexandonian/relational-set-abstraction">
            <img src={github} width="64" style={{opacity: 0.6}} />
            <Typography variant="subtitle2" style={{opacity: 0.6, marginTop: 8, marginBottom: 16, fontWeight: 100}}>
              Code and pretrained models
            </Typography>
          </a>
        </div>
        <div id="Team"></div>
        <div className={classes.teamContainer}>
          <Typography variant="h4" style={{marginTop: 32,fontWeight: 200}}>
            Team
          </Typography>
          <div className={classes.peopleContainer}>
            {
              Object.keys(people).map((key, index) => {
                return  (<Avatar src={people[key]["src"]} role={people[key]["email"]} name={key} />);
              })
            }
          </div>
        </div>
      </div>
      <div className={classes.divider} />
      <div className={classes.copyright}>
        Designed and Created by Allen Lee (allenlee-At-mit.edu).
      </div>
    </div>
  );
}

function Avatar(props) {
  const classes = useStyles();

  return (
    <div className={classes.personContainer}>
      <div className={classes.avatarContainer}>
        <img src={require(`${props.src}`)} className={classes.imgSizing} />
      </div>
      <Typography className={classes.nameText}>
        {props.name}
      </Typography>
      <Typography className={classes.roleText}>
        {props.role}
      </Typography>
    </div>
  );
}
export default App;
